import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as environmentActions } from "reducers/environment";
import { actions as onboardingActions } from "reducers/onboarding";

export const useTaxSelector = () => {
    const taxSelectorRequest = useSelector((state) => state?.environment?.taxSelectorRequest);
    const { role = [] } = useSelector((state) => state?.onboarding?.userRoleRequest?.value);
    const isLegalRepresentative = role === "REPRESENTANTE_LEGAL";

    const dispatch = useDispatch();

    const { status: taxSelectorRequestStatus, value: taxSelectorRequestValue } = taxSelectorRequest;

    useEffect(() => {
        dispatch(environmentActions.getTaxSelectorRequest());
        if (!role) {
            dispatch(onboardingActions.getUserRole());
        }
    }, [dispatch]);

    return { taxSelectorRequestValue, taxSelectorRequestStatus, isLegalRepresentative };
};

export default useTaxSelector;
